import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './theme/index.css'
import { initializeDatabase } from '@/services/index'
import AntdConfig from './theme/antd/index.tsx'
import { useNovelCoreStore } from '@/stores/novelCoreStore'

// 初始化应用
const initAndRender = async () => {
  try {
    // 在渲染应用前初始化IndexDB
    await initializeDatabase()

    await useNovelCoreStore.getState().initCoreData()

    ReactDOM.createRoot(document.getElementById('root')!).render(
      <React.StrictMode>
        <AntdConfig>
          <App />
        </AntdConfig>
      </React.StrictMode>,
    )
  } catch (error) {
    console.error('应用初始化失败:', error)
    // 显示错误信息
    document.getElementById('root')!.innerHTML = `
      <div style="
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100vh;
        font-family: Arial, sans-serif;
        color: #ff4d4f;
        text-align: center;
        padding: 20px;
      ">
        <div>
          <h2>应用初始化失败</h2>
          <p>请刷新页面重试，或检查浏览器是否支持IndexDB</p>
          <p style="font-size: 12px; color: #999;">错误信息: ${error instanceof Error ? error.message : '未知错误'}</p>
        </div>
      </div>
    `
  }
}

// 启动应用
initAndRender() 